export default __webpack_public_path__ + "static/KeywordResearch_01_01-024f3340972ab2821492f3bc3e75c58f.webp";